export const bolcomApp = {
  id: 94,
  name: "bolcom",
  label: "Bol.com",
  showTestConnection: true,
  isMarketplace: true,
  logo: process.env.BASE_URL + "media/shopLogos/bolcom.svg",
  areaBlacklist: ["migration", "reporting"],
  additional_params: {
    authType: "client_credentials",
    requestMethod: "POST",
    endpoint: "token",
    requestHeaders: {
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json"
    },
    body: {
      grant_type: "client_credentials"
    }
  },
  environmentVariables: {
    presetId: process.env?.VUE_APP_SCM_APP_BOLCOM_PRESET_ID,
    testBatchWorkflows: {
      salesOrder:
        process.env?.VUE_APP_SCM_APP_BOLCOM_TEST_BATCH_ORDER_WORKFLOW_ID
    },
    CFLDataSetId: process.env?.VUE_APP_SCM_APP_BOLCOM_REPORTING_CFL_DATASET_ID,
    syncBatchWorkflowId:
      process.env.VUE_APP_SCM_APP_BOLCOM_REPORTING_SYNC_BATCH_WORKFLOW_ID
  }
};
